export const formatInterval = (minutes: number) => {
  // Less than an hour: show in minutes
  if (minutes < 60) {
    return minutes === 1 ? "1-minute" : `${minutes}-minute`;
  }

  const hours = minutes / 60;

  // Exact hours (no fractional part)
  if (Number.isInteger(hours)) {
    // 24+ hours: show in days if exact days
    if (hours > 24 && hours % 24 === 0) {
      const days = hours / 24;
      return `${days}-day`;
    }
    return `${hours}-hour`;
  }

  // Fractional hours: break down into hours and minutes
  const wholeHours = Math.floor(hours);
  const remainingMinutes = minutes % 60;

  if (wholeHours === 0) {
    return `${remainingMinutes}-minute`;
  }
  return `${wholeHours}h ${remainingMinutes}m`;
};
